import React, { useCallback } from 'react';
import { Box, TextLink } from '@indeed/ifl-components';
import { storeUrl, WEB_APP_EXTERNAL_PATH } from 'Constants/AppLinks';
import AppVersionUtil from 'Utils/AppVersionUtil';
import JsvMetricsLogger from 'Utils/JsvMetricsLogger';
/**
 * The nudge itself — text and destination, no surface of its own.
 *
 * Two places render it: the dismissible banner in normal page flow, and the login dialog,
 * which is the only way to reach a returning user whose session expired (they land on
 * /home behind a modal that marks everything outside it aria-hidden). Keeping the copy,
 * the destination and the metric in one place is what stops those two drifting apart.
 *
 * Self-gating: renders nothing when the running app is current, so callers can drop it in
 * without repeating the version check.
 */
const AppUpdateMessage = ({ recommendedVersion, minSupportedIosVersion, asParagraph = false }) => {
    // Below the OS floor the store has nothing newer to give, so "update" is a dead end.
    const canUpdate = AppVersionUtil.canInstallLatest(minSupportedIosVersion);
    const handleClick = useCallback(() => {
        JsvMetricsLogger.log('click', 'app_update_banner', canUpdate ? 'app_update_open_store' : 'app_update_open_web');
    }, [canUpdate]);
    if (!AppVersionUtil.shouldPromptUpdate(recommendedVersion)) {
        return null;
    }
    const message = canUpdate ? (React.createElement(React.Fragment, null,
        "\u30A2\u30D7\u30EA\u306E\u65B0\u3057\u3044\u30D0\u30FC\u30B8\u30E7\u30F3\u304C\u3042\u308A\u307E\u3059\u3002",
        React.createElement(TextLink, { href: storeUrl(), onClick: handleClick }, "\u6700\u65B0\u7248\u306B\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002"))) : (React.createElement(React.Fragment, null,
        "\u304A\u4F7F\u3044\u306EOS\u306F\u30A2\u30D7\u30EA\u306E\u6700\u65B0\u7248\u306B\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
        React.createElement(TextLink, { href: WEB_APP_EXTERNAL_PATH, onClick: handleClick }, "\u30D6\u30E9\u30A6\u30B6\u7248\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002")));
    return asParagraph ? (React.createElement(Box, { "data-testid": "app-update-paragraph", sx: { marginBottom: 4 } }, message)) : (message);
};
export default AppUpdateMessage;
